import { AdjacentType, LogicalOperatorType, } from '@iotv/iotv-v3-types';
export const getAllDevicesQuery = (customers, andDeviceAttributeFilters) => {
    const query = {
        Items: customers,
        queryPath: [
            {
                objectTypeId: 'Property',
                adjacencyType: AdjacentType.CHILD,
            },
            {
                objectTypeId: 'Device',
                adjacencyType: AdjacentType.CHILD,
            },
        ],
    };
    if (andDeviceAttributeFilters) {
        query.queryPath[1].nodeFilters = [
            {
                filters: andDeviceAttributeFilters,
                setOperation: LogicalOperatorType.AND,
            },
        ];
    }
    return query;
};
export const getDevicesViaCustomer = (source, andDeviceAttributeFilters) => {
    const query = {
        Items: source,
        queryPath: [
            {
                objectTypeId: 'Property',
                adjacencyType: AdjacentType.CHILD,
            },
            {
                objectTypeId: 'Device',
                adjacencyType: AdjacentType.CHILD,
            },
        ],
    };
    if (andDeviceAttributeFilters) {
        query.queryPath[1].nodeFilters = [
            {
                filters: andDeviceAttributeFilters,
                setOperation: LogicalOperatorType.AND,
            },
        ];
    }
    return query;
};
export const getDevicesViaProperty = (source, andDeviceAttributeFilters) => {
    const query = {
        Items: source,
        queryPath: [
            {
                objectTypeId: 'Device',
                adjacencyType: AdjacentType.CHILD,
            },
        ],
    };
    if (andDeviceAttributeFilters) {
        query.queryPath[0].nodeFilters = [
            {
                filters: andDeviceAttributeFilters,
                setOperation: LogicalOperatorType.AND,
            },
        ];
    }
    return query;
};
